import _cloneDeep from 'lodash/cloneDeep';
import initState from '../../reducers/redux-initial-state';
import {types} from './constants';
import {getAllowedBlockedNetworkChartData, getValidData} from '../../utils/dashboard';

export default (state = initState.organizationEditFormReducer, action) => {
  switch (action.type) {
    case types.SET_EDITABLE_ORGANIZATION_INFO: {
      const newState = _cloneDeep(state);
      newState.editableOrganizationInfo = _cloneDeep(action.organizationInfo);
      return newState;
    }
    case types.RESET_ORGANIZATION_EDIT_FORM_DATA: {
      return _cloneDeep(initState.organizationEditFormReducer);
    }
    case types.SET_VALIDATION_ORGANIZATION_INFO: {
      return {
        ...state,
        isValidOrganizationInfo: action.isValid,
      };
    }
    case types.UPDATE_ORGANIZATION_INFO: {
      return {
        ...state,
        editableOrganizationInfo: action.updatedOrganizationInfo,
        isValidOrganizationInfo: action.isValidOrganizationInfo,
      };
    }
    case types.SET_ORGANIZATION_SELECTED_PERIOD_INDEX: {
      return {
        ...state,
        selectedPeriodIndex: action.index,
      };
    }
    case types.SET_ORGANIZATION_AVERAGE_LATENCY: {
      return {
        ...state,
        averageLatency: parseInt(getValidData(action.data), 10),
      };
    }
    case types.SET_ORGANIZATION_STATS: {
      return {
        ...state,
        requestsPerSecond: getValidData(action.data.requestsPerSecond),
        requestsByDecision: action.data.requestsByDecision,
      };
    }
    case types.SET_ORGANIZATION_THREATS: {
      return {
        ...state,
        threatStats: action.data,
      };
    }
    case types.SET_ORGANIZATION_REQUESTS_GRAPH: {
      return {
        ...state,
        userRequestsGraph: {
          chartData: getAllowedBlockedNetworkChartData(
            action.data,
            action.period,
          ),
        },
      };
    }

    default:
      return state;
  }
};
